export default __webpack_public_path__ + "static/media/ICO-arrows-down.1f52bd76.svg";